import React from "react";
import Fallback from "app/views/common/components/Fallback";

const Landing = React.lazy(() => import("app/views/pages/Landing"));
const Drivers = React.lazy(() =>
  import("app/views/pages/Drivers/Drivers/Drivers")
);
const PageNotFound = React.lazy(() => import("app/views/pages/PageNotFound"));

const PAGES = {
  LANDING: (props) => (
    <React.Suspense fallback={<Fallback />}>
      <Landing {...props} />
    </React.Suspense>
  ),
  DRIVERS: (props) => (
    <React.Suspense fallback={<Fallback />}>
      <Drivers {...props} />
    </React.Suspense>
  ),
  PAGE_NOT_FOUND: (props) => (
    <React.Suspense fallback={<Fallback />}>
      <PageNotFound {...props} />
    </React.Suspense>
  ),
};

export default PAGES;
